module.exports = __webpack_public_path__ + "img/Logistics-Warehouseexpressfreightlabel.0dda1e6b.jpg";